import { useLayoutEffect } from "react";

export const useBodyScrollLock = (isLocked) => {
  useLayoutEffect(() => {
    if (isLocked) {
      const originalStyle = window.getComputedStyle(document.documentElement).overflow;
      document.documentElement.style.overflow = "hidden";
      return () => {
        document.documentElement.style.overflow = originalStyle;
      };
    }
  }, [isLocked]);
};
